import { Column } from "@@/shared/components/column";
import { Row } from "@@/shared/components/row";
import { Span } from "@@/shared/text/span";
import {
    faClipboardCheck,
    faHeart,
    faUsers,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BookableUspInfoBlock = () => {
    return (
        <Column className="space-y-5">
            <Row crossAxis="start" className="space-x-1">
                <Column crossAxis="start" className="w-7 space-x-2">
                    <FontAwesomeIcon
                        icon={faClipboardCheck}
                        className="text-primary pt-1 text-base"
                        fixedWidth
                    />
                </Column>
                <Column className="flex-1 space-y-0.5">
                    <Row>
                        <Span
                            text={{
                                sv: "Boka direkt, säkra din plats",
                                en: "Book directly, secure your spot",
                                de: "Direkt buchen, Platz sichern",
                            }}
                            className="text-base font-bold select-text"
                        />
                    </Row>
                    <Span
                        text={{
                            sv: "Utforska och beställ direkt här. Mindre köande. Snabbt och enkelt säkrar du din bokning.",
                            en: "Explore and order directly here. Less queuing. Quickly and easily you secure your booking.",
                            de: "Direkt hier buchen. Weniger Schlange stehen. Schnell und einfach sichern Sie Ihre Buchung.",
                        }}
                        className="text-sm font-normal text-neutral-700 select-text"
                    />
                </Column>
            </Row>
            <Row crossAxis="start" className="space-x-1">
                <Column crossAxis="start" className="w-7 space-x-2">
                    <FontAwesomeIcon
                        icon={faUsers}
                        className="text-primary pt-1 text-base"
                        fixedWidth
                    />
                </Column>
                <Column className="flex-1 space-y-0.5">
                    <Row>
                        <Span
                            text={{
                                sv: "Dela och upplev tillsammans",
                                en: "Share and experience together",
                                de: "Teilen und gemeinsam erleben",
                            }}
                            className="text-base font-bold select-text"
                        />
                    </Row>
                    <Span
                        text={{
                            sv: "Dela gärna din bokning eller beställning. Tillsammans blir det roligare!",
                            en: "Feel free to share your booking or order. Together it becomes more fun!",
                            de: "Teilen Sie gerne Ihre Buchung oder Bestellung. Zusammen macht es mehr Spaß!",
                        }}
                        className="text-sm font-normal text-neutral-700 select-text"
                    />
                </Column>
            </Row>
            <Row crossAxis="start" className="space-x-1">
                <Column crossAxis="start" className="w-7 space-x-2">
                    <FontAwesomeIcon
                        icon={faHeart}
                        className="text-primary pt-1 text-base"
                        fixedWidth
                    />{" "}
                </Column>
                <Column className="flex-1 space-y-0.5">
                    <Row>
                        <Span
                            text={{
                                sv: "Klart på studs, bara dyka upp",
                                en: "Ready on the spot, just show up",
                                de: "Bereit auf der Stelle, einfach erscheinen",
                            }}
                            className="text-base font-bold select-text"
                        />
                    </Row>
                    <Span
                        text={{
                            sv: "Du får bekräftelse på momangen, där finns all information du behöver inför besöket. Smidigt!",
                            en: "You will receive confirmation of the appointment, which contains all the information you need before the visit. Smooth!",
                            de: "Sie erhalten eine Bestätigung des Termins, die alle Informationen enthält, die Sie vor dem Besuch benötigen. Glatt!",
                        }}
                        className="text-sm font-normal text-neutral-700 select-text"
                    />
                </Column>
            </Row>
        </Column>
    );
};

export { BookableUspInfoBlock };
